import React, { useEffect, useState } from "react";

import GlobalContext from "../../../contexts/globalContext";
import LoadingPage from "../../atoms/loading-page/loading-page";
import { axiosInstance } from "../../../services/axios-instance";
import useLoginGigya from "../../../shared/hooks/useLoginGigya";

const EmptyLayout = (props: any) => {
  const [token, setToken] = useState({});
  const [loading, setLoading] = useState(false);
  const gigyaContext = useLoginGigya();

  const getToken = async () => {
    try {
      if (gigyaContext.gigyaAccount) {
        // setLoading(true);
        const gigya = gigyaContext.gigyaAccount;
        const dataUser = {
          uid: gigya.UID,
          signaturetimestamp: gigya["signatureTimestamp"],
          uidsignature: gigya.UIDSignature,
          cellPhone: gigya.data.mobile,
        };
        const url = process.env.URL_NUTRICIONSALUDABLE_USER;
        const endpoint = "/getToken";
        const config = {
          headers: {
            'x-api-key': process.env.APIKEY_SALUD,
            'Content-Type': 'application/json', 
          },
        };
        const resp = await axiosInstance.post(`${url}${endpoint}`, dataUser, config);
        const {
          data: { data },
        } = resp;
        if (data) {
          setToken({
            ...token,
            data,
          });
        }

        localStorage.setItem("uid-r", gigyaContext.gigyaAccount.UID);
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (gigyaContext.gigyaAccount?.UID) {
      getToken();
    }
    // return setToken({});
  }, [gigyaContext.gigyaAccount?.UID]);

  const context = {
    gigyaContext: { ...gigyaContext },
    userInfoContext: { ...token },
  };

  return (
    <GlobalContext.Provider value={context}>
      {loading && <LoadingPage />}
      <main>{props.children}</main>
    </GlobalContext.Provider>
  );
};

export default EmptyLayout;
